import { booleanAttribute, Component, input } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'ae-form-label',
	templateUrl: './form-label.component.html',
	styleUrls: ['./form-label.component.scss'],
	imports: [NgbTooltip],
	host: { class: 'label-spacer' },
})
export class FormLabelComponent {
	readonly label = input.required<string>();
	readonly for = input.required<string>();
	readonly required = input(false, { transform: booleanAttribute });
	readonly proofRequired = input(false, { transform: booleanAttribute });
}
